import { gql } from "apollo-boost";

export const GET_HISTORY_BY_PATIENT = gql`
  query getHistoryByPatientId(
    $where: AppointmentHistoriesByIdWhereInput
    $relations: [String]
  ) {
    getHistoryByPatientId(where: $where, relations: $relations) {
      id
      date
      reason
      diseaseHistory
      appointment {
        speciality {
          id
          name
        }
      }
      medicalStaff {
        id
        name
        firstName
        middleName
        lastName
        lastName2
      }
      appointmentHistoryDiagnoses {
        id
        order
        diagnoses {
          id
          code
          description
        }
      }
    }
  }
`;
